import DeviceType, {DeviceTypeString} from 'features/POSRegisters/interfaces/DeviceType';
import React from 'react';
import styled from 'styled-components';
import SGBody from 'components/Typography/SGBody';
import SeverityBadge from 'features/POSRegisters/components/SeverityBadge';
import DeviceIcons from 'features/POSRegisters/components/DeviceIcons/DeviceIcons';
import SeverityEnum from 'features/POSRegisters/interfaces/Severity';

//#endregion Styled Components
const StyledTitleContainer = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${props => props.theme.grey}66;
  gap: 8px;
  padding-left: 24px;
  min-height: 48px;
`;

const StyledCloseButton = styled.div`
  width: 48px;
  height: 16px;
`;

const StyledDeviceType = styled(SGBody)`
  white-space: nowrap;
  text-transform: capitalize;
`;

const StyledDeviceName = styled(SGBody)`
  text-transform: uppercase;
  white-space: nowrap;
`;

const StyledDeviceIcons = styled(DeviceIcons)`
  color: ${props => props.theme.disabledStateBlue};
  /* color: red; */
`;

const StyledDivider = styled.div`
  width: 1px;
  height: 24px;
  background-color: ${props => props.theme.grey}66;
  margin: 0 8px;
`;
//#endregion Styled Components

//#region Component
interface ModalIconTitleProps {
  deviceType: DeviceType;
  deviceName?: string;
  severity?: SeverityEnum;
  children?: React.ReactNode;
}

export default function ModalIconTitle({
  deviceName,
  deviceType,
  severity,
  children,
}: ModalIconTitleProps) {
  return (
    <StyledTitleContainer>
      {severity ? (
        <SeverityBadge severity={severity} size={1} />
      ) : (
        <StyledDeviceIcons deviceType={deviceType} />
      )}
      <StyledDeviceType>{DeviceTypeString[deviceType]}</StyledDeviceType>

      {deviceName && <SGBody>-</SGBody>}
      {deviceName && <StyledDeviceName>{deviceName}</StyledDeviceName>}

      {children && <StyledDivider />}
      {children}
      <StyledCloseButton />
    </StyledTitleContainer>
  );
}
//#endregion Component
